import { useMutation } from '@tanstack/react-query';
import {
  AccountProvisioningError,
  applyAccountProvisioningDefaults,
} from 'services/AccountProvisioning.Service';

const MAX_RETRIES = 2;

export const useApplyAccountProvisioningDefaults = () =>
  useMutation({
    mutationFn: ({ accountId }: { accountId: string }) => applyAccountProvisioningDefaults(accountId),
    retry: (failureCount, error: unknown) => {
      if (failureCount >= MAX_RETRIES) {
        return false;
      }

      return !(error instanceof AccountProvisioningError) || error.status >= 500;
    },
  });
